// removed by extract-text-webpack-plugin
module.exports = {"overflow-y-scroll":"BatchSentItemsApp__overflow-y-scroll___2pd9N"};